import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { SharedFileSasKey } from "../../_objects/inspection-image";
import { HttpService } from "../http.service";
import { SharedFileContractService } from "../interfaces/shared-file-contract.service";
import { InspectionStructureFormat } from "../../_utils/inspection-structure.utils";

@Injectable({
  providedIn: "root"
})
export class SharedFileOnlineService extends HttpService implements SharedFileContractService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }
  sharedFileSasKey(
    dataId: string,
    dataType: string,
    startDate: string,
    expiryDate: string,
    sharedUserMailAddress: string[],
    structureFormat?: InspectionStructureFormat
  ): Observable<string> {
    const endpoint = super.getEndpoint("shared", "file");

    const formData = new SharedFileSasKey();
    formData.dataId = dataId;
    formData.dataType = dataType;
    formData.startDate = startDate;
    formData.expiryDate = expiryDate;
    formData.sharedUserMailAddress = sharedUserMailAddress;
    formData.structureFormat = structureFormat;

    return this.http
      .put<string>(endpoint, formData, { withCredentials: super.getWithCredentialsOption() })
      .pipe(map((response) => response as string));
  }
}
